import React from 'react';

export default function Footer({menu, info}) {
    return (
        <footer
            id="page-footer"
            className={`bg-black text-body- mt-5`}
        >
            <div className="content py-0">
                <div className="row font-size-sm mb-3">
                    <div className="col-sm-4 order-sm-1 text-center text-sm-left">
                        &copy; Rastro+{" "}
                        <span data-toggle="year-copy">{new Date().getFullYear()}</span> - Todos os direitos reservados
                    </div>
                    <div className="col-sm-4 order-sm-1 text-center text-white">
                        <a href="https://navigate.one" className="text-white" target="_blank" rel="noreferrer">Desenvolvido pela Navigate</a>
                    </div>
                    <div className="col-sm-4 order-sm-1 text-center text-sm-right">
                        versão 0.0.1
                    </div>
                </div>
            </div>
        </footer >
    );
}